import React from 'react'
import { useState } from 'react'
import "./navbar.css"
import { Button } from '@chakra-ui/react'

import Sumit_Kolipyaka_Resume from "../assets/Sumit_Kolipyaka_Resume.pdf"


      
const Navbar = () => {
    const [toggle,SetToggel]=useState(false)
    const [click, setClick] = React.useState(false);

    const handleClick = () => setClick(!click);
    const Close = () => setClick(false);
  
    function handleResume() {
      window.open("https://drive.google.com/file/d/17yzMuxCMDSt2beklzFw1laz-h6Y9IRlq/view?usp=sharing");
  
    }

  return (
    <header className='header' id="nav-menu">
        <nav className='nav container'>
            <a href="index.html" className='nav-logo'>SUMIT</a>

            <div className={toggle?'nav__menu show-menu':'nav__menu'}>
                <ul className='nav__list grid'>
                    <li className="nav-link home">
                        <a href="#home" className='nav__link active-link'>
                        <i className='uil uil-estate nav__icon'></i>Home
                        </a>
                    </li>

                    <li className='nav-link about'>
                        <a href="#about" className='nav__link'>
                        <i className='uil uil-user nav__icon'></i>About
                        </a>
                    </li>

                    <li className='nav-link skills'>
                        <a href="#skills" className='nav__link'>
                        <i className='uil uil-file-alt nav__icon'></i> Skills
                        </a>
                    </li>

                    <li className='nav-link projects'>
                        <a href="#projects" className='nav__link'>
                        <i className='uil uil-briefcase nav__icon'></i>Projects
                        </a>
                    </li>


                    <li className='nav__item'>
                        <a href="#stats" className='nav__link'>
                        <i className='uil uil-scenery nav__icon'></i>Stats
                        </a>
                    </li>


                    <li className='nav-link contact'>
                        <a href="#contact" className='nav__link'>
                        <i className='uil uil-message nav__icon'></i>Contact
                        </a>
                    </li>




<li className="nav-item" >
{/* <Button
              bg={"white"}
              border={"solid white"}
              _hover={{
                bg: "brown",
                color:"black"
                
              }}
              size={'md'}
              height={"42px"}
              width={"120%"}
              borderRadius={"10px"}    
              id="resume-button-1"
            > */}
              <a href={Sumit_Kolipyaka_Resume} download={true} target='_blank'
                className="nav-link resume" id="resume-link-1"
                onClick={click ? handleClick : null}

              >
                <Button id="resume-button-1" onClick={handleResume}  bg="white" _hover={{
                bg: "brown",
                color:"white"
                
              }}> Resume</Button>

              </a>
              {/* </Button> */}
            </li> 



                </ul>
                <i className='uil uil-times nav__close' onClick={()=>SetToggel(!toggle)}></i>
            </div>
           <div className='nav__toggle' onClick={()=>SetToggel(!toggle)}>
           <i className='uil uil-apps'></i>
           </div>
        </nav>

    </header>
  )
}

export default Navbar